module.exports = __webpack_public_path__ + "img/kogonia.d908ef44.jpg";